export const baseImageUrl = 'https://nespresso-front-static-images.s3.ap-south-1.amazonaws.com'

export const startPoint = '/digital-point'